/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Claim_Replacement_Not_CreatableInputs */

const en_error_claim_replacement_not_creatable = /** @type {(inputs: Error_Claim_Replacement_Not_CreatableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The replacement of this claim cannot be made as asked.`)
};

/**
* | output |
* | --- |
* | "The replacement of this claim cannot be made as asked." |
*
* @param {Error_Claim_Replacement_Not_CreatableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_claim_replacement_not_creatable = /** @type {((inputs?: Error_Claim_Replacement_Not_CreatableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Claim_Replacement_Not_CreatableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_claim_replacement_not_creatable(inputs)
});